import cacheUtil, { CACHE_WORKSPACE_KEY } from '@/utils/cache'
import uuidUtil from '@/utils/uuid'
import { setEmptyUserInfo, setEmptyUserRelations } from '@/store/user'
import React, { memo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import logo from '@/assets/images/logo.png'
import styles from './index.module.scss'
import { LANGUAGE_KEY } from '@/services/i18n'
import { useSelector, useDispatch } from 'react-redux'
import { AppDispatch, AppState } from '@/store/types'
import { UserModel, WorkspaceInfoModel } from '@/services/apis/user/model'
import arrow from '@/assets/images/arrow-bottom.png'
import UserApi from '@/services/apis/user'
import { formatTime2 } from '@/utils/format'
import { Avatar, Button, Popover } from 'antd'

import { WorkspaceMemberModel } from '@/services/apis/user/model'
import { LanguageEnum, LanguageMap } from '@/services/i18n/index'
import checkedImg from '@/assets/images/checked.svg'
import LogoContent from '../LogoContent'
import { useNavigate } from 'react-router-dom'
const Header = memo(() => {
  const { i18n, t } = useTranslation()

  const navigate = useNavigate()
  const workspaceInfo = useSelector<AppState, WorkspaceInfoModel>(state => state.user.workspaceInfo)
  const workspaceMember = useSelector<AppState, WorkspaceMemberModel>(
    state => state.user.workspaceMember
  )
  const userInfo = useSelector<AppState, UserModel>(state => state.user.userInfo)
  const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL
  const isLogin = () => {
    return !!uuidUtil.getUUID()
  }
  const isSelectWallet = () => {
    return !!cacheUtil.get(CACHE_WORKSPACE_KEY)
  }
  const handleContact = () => {
    window.open(`${WEBSITE_URL}/${i18n.language}/contact-us`)
  }

  const dispatch = useDispatch<AppDispatch>()
  const logout = async () => {
    const res = await UserApi.logout()
    if (res.success) {
      uuidUtil.deleteUUID()
      dispatch(setEmptyUserInfo())
      // 清空团队
      dispatch(setEmptyUserRelations())
      navigate('/login')
    }
  }
  const changLanguage = (lang: any) => {
    if (i18n.language === lang) return

    cacheUtil.set(LANGUAGE_KEY, lang)

    window.location.reload()
    // navigate(location.pathname)

    i18n.changeLanguage(lang)
  }
  const i18Pop = Object.values(LanguageEnum).map(lang => {
    return (
      <div key={lang} className={styles.i18nContainer} onClick={() => changLanguage(lang)}>
        <span>{LanguageMap[lang]}</span>
        {i18n.language === lang && <img width="16" src={checkedImg} alt=""></img>}
      </div>
    )
  })
  const ref = useRef<any>(null)

  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.left}>
        {isLogin() && isSelectWallet() ? (
          <div className={styles.team}>
            <Popover
              content={<LogoContent />}
              trigger="hover"
              getPopupContainer={() => ref.current}
              overlayInnerStyle={{ marginLeft: '25px' }}
            >
              <div className={styles.account}>
                <Avatar
                  src={workspaceMember.workspacePortrait}
                  size={30}
                  style={{ marginRight: '10px' }}
                  shape="square"
                />
                <span style={{ marginRight: '10px' }}>{workspaceMember.workspaceName}</span>
                <img src={arrow} alt="" width="10" />
              </div>
            </Popover>
            {workspaceInfo.payType === 1 && (
              <div className={styles.trial}>
                <div>
                  ({t('head.remain')}:{formatTime2(workspaceInfo.probationTime)})
                </div>
                <Button
                  type="primary"
                  onClick={handleContact}
                  style={{ marginLeft: '10px', fontSize: '12px' }}
                  size="small"
                >
                  {t('head.contact')}
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.logo}>
            <a target="_blank" href={`${WEBSITE_URL}/${i18n.language}`} rel="noreferrer">
              <img src={logo} alt="" height="28"></img>
            </a>
          </div>
        )}
      </div>
      <div className={styles.right}>
        <a
          href={`${WEBSITE_URL}/${i18n.language}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: '#40464a', fontWeight: '500', marginRight: '30px' }}
        >
          {t('head.website')}
        </a>
        <Popover
          content={<div className={styles.pop}>USD</div>}
          trigger="hover"
          getPopupContainer={() => ref.current}
        >
          <div>
            <span>USD</span>
            <img src={arrow} width="10" alt="" className={styles.rightArrow} />
          </div>
        </Popover>
        <Popover
          content={<div style={{ padding: '10px 0' }}>{i18Pop}</div>}
          trigger="hover"
          getPopupContainer={() => ref.current}
        >
          <div>
            <span>{LanguageMap[i18n.language]}</span>
            <img src={arrow} width="10" alt="" className={styles.rightArrow} />
          </div>
        </Popover>
        {userInfo?.userKey && (
          <Popover
            content={
              <div onClick={logout} className={styles.logout}>
                {t('head.logout')}
              </div>
            }
            trigger="hover"
            getPopupContainer={() => ref.current}
          >
            <div>
              <span>
                <Avatar src={userInfo.userPortrait} size={30} className={styles.img} />
                <span style={{ marginLeft: '5px' }}>{userInfo.userName}</span>
              </span>
              <img src={arrow} width="10" alt="" className={styles.rightArrow} />
            </div>
          </Popover>
        )}
      </div>
    </div>
  )
})

export default Header
